import { sort } from 'fp-ts/Array';
import { getOrElse, map } from 'fp-ts/Option';
import {
  ContainerSpacedBetween,
  ContainerStackedRow,
  IndexContainerHeader,
  MainHeaderTimeRangeContainer,
  MarginlessBody2,
} from 'modules/intelligentInsights/IntelligentInsights.styles';
import { Select } from 'ui/selectv2/Select';
import {
  asTimespanEnum,
  asTimespanOption,
  formatAsCommonDate,
  getInsightsHistory,
  IntelligentInsightsTimeSpanOptions,
  ordByDate,
} from 'modules/intelligentInsights/domain.utils';
import { FREQUENCY_OPTIMIZATION_INSIGHTS, VIEWING } from 'modules/intelligentInsights/constants';
import { FREQUENCY_PERIOD } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/constants';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import {
  FroInsightsData,
  MessageMediumByTimeData,
} from 'modules/intelligentInsights/frequencyOptimization/types';
import { isEmpty } from 'lodash';
import { LastUpdatedDate } from 'modules/intelligentInsights/common/LastUpdatedDate';
import { getMessageMediumByTimeByFrequencyPeriod } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/utils';

const sortByDate = map(sort(ordByDate));
export const getLastUpdatedOn = (froInsightsData: FroInsightsData) => {
  const messageMediumByTimeMetrics = getInsightsHistory(froInsightsData);
  const messageMediumByTimeMetricsData = getMessageMediumByTimeByFrequencyPeriod(
    messageMediumByTimeMetrics,
    FREQUENCY_PERIOD.WEEKLY,
  );
  const sortedRawData = getOrElse(() => [] as MessageMediumByTimeData[])(
    sortByDate(messageMediumByTimeMetricsData),
  );
  if (isEmpty(sortedRawData)) {
    return 'N/A';
  }
  return formatAsCommonDate(sortedRawData[sortedRawData.length - 1].endDate);
};

export const FrequencyOptimizationInsightsMainHeader = () => {
  const {
    froInsightsData,
    isLoading,
    timeSpan: { selectedTimespan, updateTimespan },
  } = useFroInsightsCoreContext();
  const lastUpdatedOn = getLastUpdatedOn(froInsightsData);
  return (
    <>
      <ContainerSpacedBetween>
        <ContainerStackedRow>
          <IndexContainerHeader>{FREQUENCY_OPTIMIZATION_INSIGHTS}</IndexContainerHeader>
          <LastUpdatedDate isLoading={isLoading} lastUpdatedText={lastUpdatedOn} />
        </ContainerStackedRow>
        <MainHeaderTimeRangeContainer>
          <MarginlessBody2>{VIEWING}</MarginlessBody2>
          <Select
            usePortal
            isDisabled={isLoading}
            isMulti={false}
            options={IntelligentInsightsTimeSpanOptions}
            value={[asTimespanOption(selectedTimespan)]}
            onSelect={([option]) =>
              updateTimespan(
                asTimespanEnum({ value: option?.value, label: option?.label as string }),
              )
            }
            /*
            // @ts-ignore */
            isSearchable={false}
          />
        </MainHeaderTimeRangeContainer>
      </ContainerSpacedBetween>
    </>
  );
};
